<template>
    <div id="default-layout">
        <nav-header />

        <particles />

        <div id="wrap">
            <main role="main" class="container">
                <div class="row">
                    <div class="col">
                        <slot></slot>
                    </div>
                </div>
            </main>

            <div class="container-fluid" v-if="loginText.visible">
                <div class="row">
                    <div class="col px-md-5 py-4">
                        <div :class="['alert', 'text-center', 'alert-' + loginText.type]" v-html="loginText.message" />
                    </div>
                </div>
            </div>

        </div>

        <Footer />
    </div>
</template>

<script>
import NavHeader from "@/layout/parts/NavHeader"
import Particles from "@/layout/parts/Particles"
import Footer from "@/layout/parts/Footer"

export default {
    name: "DefaultLayout",
    components: {
        NavHeader,
        Footer,
        Particles
    },
    data() {
        return {
            loginText: _appConfig.login.text
        }
    }
}
</script>

<style scoped>
#wrap {
    min-height: 100%;
    height: auto;
    margin: 0 auto;
    padding: 0 0 61px;
}

.container {
    padding: 45px 15px 20px 15px;
}
</style>
